export const V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE =
  'V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE'

export default data => {
  return {
    type: V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE,
    data,
  }
}
